import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import has from 'lodash/has';

const ObjectableType = styled.span`
 color: #5bc0de;
 font-weight: 700;
`;

class Relationship extends Component {
  producerCallback = () => {
    const { activity, _pushCallback } = this.props;

    const producerId = typeof activity.data.next.producer === 'object' ?
      this.idParser('producer', activity) : null;

    if (producerId) {
      _pushCallback(activity.project_id, producerId);
    }
  }

  consumerCallback = () => {
    const { activity, _pushCallback } = this.props;

    const consumerId = typeof activity.data.next.consumer === 'object' ?
      this.idParser('consumer', activity) : null;

    if (consumerId) {
      _pushCallback(activity.project_id, consumerId);
    }
  }

  idParser = (entity, activity) => {
    return has(activity, ['data', 'next', entity, '[EL]id']) ? activity.data.next[entity]['[EL]id'] : null;
  }

  nameParser = (entity, activity, object) => {
    if (object) {
      return has(activity, ['data', 'next', entity, 'name']) ? activity.data.next[entity].name : '';
    } else {
      return has(activity, ['data', 'next', entity]) ? activity.data.next[entity] : '';
    }
  }

  render() {
    const {
      activity,
      deleteTest,
    } = this.props;

    const consumerName = typeof activity.data.next.consumer === 'object' ?
      this.nameParser('consumer', activity, true) : this.nameParser('consumer', activity, false);
    const producerName = typeof activity.data.next.producer === 'object' ?
      this.nameParser('producer', activity, true) : this.nameParser('producer', activity, false)

    return (
      <span>
        <Link>
          {has(activity, ['user', 'first_name']) ? activity.user.first_name : ''}
          {' '}
          {has(activity, ['user', 'last_name']) ? activity.user.last_name : ''}
        </Link>
        {' '}
        {deleteTest ? 'deleted' : 'added'}
        {' '}
        a relationship
        {' '}
        from
        {' '}
        <ObjectableType>
          <Link onClick={this.consumerCallback} style={{ cursor: 'pointer' }}>{consumerName}</Link>
        </ObjectableType>
        {' '}
        to
        {' '}
        <ObjectableType>
          <Link onClick={this.producerCallback} style={{ cursor: 'pointer' }}>{producerName}</Link>
        </ObjectableType>
      </span>
    );
  }
}

Relationship.propTypes = {
  activity: PropTypes.object,
  deleteTest: PropTypes.bool,
  _pushCallback: PropTypes.func,
};

export default Relationship;



// WEBPACK FOOTER //
// ./src/components/ActivityFeed/ActivityTypes/Relationship.js